/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import "./HomeBanner.css";
import Typewriter from "typewriter-effect";

const HomeBanner = () => {
  return (
    <div className="hero min-h-screen">
      <div className="hero-content flex-col gap-x-12 lg:flex-row-reverse">
        <div className="avatar">
          <div className="rounded-full bg-primary">
            <img
              src="https://i.ibb.co/Px1HDfT/passport-size-removebg-preview.png"
              alt=""
            />
          </div>
        </div>
        <div>
          <h1 className="text-4xl font-bold Name">
            <span className="text-primary">Hello!</span>
            <span className="text"> My Name is</span>{" "}
          </h1>
          <h1 className="text-6xl font-bold Name mt-6">Nur Mohammad Rayhan</h1>
          <p className="text-3xl mb-6 text-gray-500 py-2">
            {" "}
            I'm a Junior Web Developer with Expertise on
            <span className="text-primary font-mono font-bold text-3xl">
              <Typewriter
                options={{
                  strings: [
                    "HTML",
                    "CSS",
                    "Javascript",
                    "Bootstrap",
                    "Tailwind CSS",
                    "ReactJS"
                  ],
                  autoStart: true,
                  loop: true,
                  delay: 200,
                  deleteSpeed: 50,
                }}
              />
            </span>
          </p>
          <a
            className="btn btn-primary text-xl"
            href="https://docs.google.com/document/d/1HTiCF5XEoZpJMgQgNWZSpn0jk4iLZnhhz58DGbgctL4/edit?usp=sharing"
            target="_blank"
          >
            Download Resume
          </a>
        </div>
      </div>
    </div>
  );
};

export default HomeBanner;
